import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Brazil = () => {
    return <SharedDocumentsComponent permissionId="36" path="Brasil" />
}